import OSS from '../lib/ossComponents.json';
import TEXTS from '../lib/ossTexts.json';

// "About the app → open-source licences": built from the audited central list, texts embedded in the bundle (offline)
function Text({ t, f, id }) {
  return (
    <details>
      <summary data-testid={`lic-file-${id}-${f}`}>{t.licOrig}: {f}</summary>
      <pre className="lic-pre" data-testid={`lic-text-${id}-${f}`}>{TEXTS[f]}</pre>
    </details>
  );
}

// large file (all libraries): opened as plain text, precached by the service worker for offline use
const AllNotices = ({ t }) => <a className="btn btn-outline btn-sm" data-testid="lic-all-link" href="/licenses/THIRD_PARTY_NOTICES.txt" target="_blank" rel="noreferrer">{t.licAll}</a>;

const ENG = ['owa-epanet', 'epanet-js', 'swmm'];
export const EngineLine = () => <p className="muted" data-testid="about-engines">{OSS.components.filter((c) => ENG.includes(c.id)).map((c) => `${c.name.split(' (')[0]} ${c.ver.split(' ')[0]}`).join(' · ')}</p>;

export function OssLicenses({ t }) {
  const eng = typeof window !== 'undefined' ? window.__gissEpanetVer : null;
  return (
    <details className="md-block" data-testid="settings-licenses">
      <summary data-testid="settings-licenses-toggle">{t.licTitle}</summary>
      <p className="muted">{t.licIntro}</p>
      <p className="muted" data-testid="lic-no-endorse">{t.licNoEndorse}</p>
      {eng && <p className="muted" data-testid="lic-engine-runtime">{t.licEngine}: OWA-EPANET {eng}</p>}
      {OSS.components.map((c) => (
        <div key={c.id} className="lic-item" data-testid={`lic-${c.id}`}>
          <b>{c.name}</b> · {c.ver} · {c.lic}
          <small>{t[`licUse_${c.use}`]}</small>
          <small>{c.holder}</small>
          <small>{c.rev} · <a href={c.repo} target="_blank" rel="noreferrer">{c.repo}</a></small>
          <small>{c.lic.startsWith('Public') ? t.licPd : t.licDuty}</small>
          {c.files.map((f) => <Text key={f} t={t} f={f} id={c.id} />)}
        </div>
      ))}
      <AllNotices t={t} />
    </details>
  );
}
